import { Badge, Button, Divider, Popover, PopoverSurface, PopoverTrigger, Text } from "@fluentui/react-components";
import { CheckmarkCircle16Filled, Dismiss16Regular, FilterFilled } from "@fluentui/react-icons";

type IProps = {
    criteriaName: string;
    criteria: string[];
    onClearCriteria: (criteriaName: string) => void;
}

const ConsumptionItemFilterComponent = (props: IProps) => {
    const firstValue = props.criteria[0] ?? '';
    const extraCount = props.criteria.length - 1;

    const chipContent = (
        <span className="filter-chip-content">
            <span className="filter-chip-label">{props.criteriaName}</span>
            <span className="filter-chip-value">{firstValue}</span>
            {extraCount > 0 && <span className="filter-chip-extra">+{extraCount}</span>}
        </span>
    );

    return (
        <div className="filter-chip">
            {props.criteria.length > 1 ? (
                <Popover withArrow>
                    <PopoverTrigger disableButtonEnhancement>
                        <button type="button" className="filter-chip-content filter-chip-content--clickable">
                            <span className="filter-chip-label">{props.criteriaName}</span>
                            <span className="filter-chip-value">{firstValue}</span>
                            {extraCount > 0 && <span className="filter-chip-extra">+{extraCount}</span>}
                        </button>
                    </PopoverTrigger>
                    <PopoverSurface tabIndex={-1} className="filter-chip-popover-surface">
                        <div className="filter-chip-popover-header">
                            <FilterFilled fontSize={14} className="filter-chip-popover-icon" />
                            <Text size={200} weight="semibold" className="filter-chip-popover-title">
                                {props.criteriaName}
                            </Text>
                            <Badge size="small" shape="rounded" appearance="tint" color="informative">
                                {props.criteria.length}
                            </Badge>
                        </div>
                        <Divider className="filter-chip-popover-divider" />
                        <ul className="filter-chip-popover-list">
                            {props.criteria.map((c) => (
                                <li key={c} className="filter-chip-popover-item">
                                    <CheckmarkCircle16Filled className="filter-chip-popover-check" />
                                    <Text size={200}>{c}</Text>
                                </li>
                            ))}
                        </ul>
                    </PopoverSurface>
                </Popover>
            ) : (
                chipContent
            )}
            <Button
                size="small"
                appearance="subtle"
                shape="circular"
                icon={<Dismiss16Regular />}
                onClick={(e) => {
                    e.stopPropagation();
                    props.onClearCriteria(props.criteriaName);
                }}
            />
        </div>
    );
}

export default ConsumptionItemFilterComponent;